/* @flow strict */

import _ from 'lodash';

const validateQuestionLevels = (questions: [], scrollCb: (HTMLElement) => void): boolean => {
  let isValid = true;

  const defaultNodeEl = {
    style: {}
  };

  _.map(questions, (t: {}, i: number): boolean => {
    const el = document.querySelector(`.QuestionLevelItem[data-tli="${_.get(t, 'temp_id', t.id)}"]`);

    if (!el) {
      console.warn(
        'document.querySelector(`.QuestionLevelItem[data-tli="${_.get(t, \'temp_id\', t.id)}"]`) is not defined'
      );
      return true;
    }

    const response = el.querySelector('.react-tagsinput');
    const responseVMsg = (response && response.nextSibling) || defaultNodeEl;


    let invalidEl = null;

        if (t.display_type !== 'TextBox' && !_.size(t.options)) {
            response.classList.add('validationElement');
             responseVMsg.style.display = 'block';

             invalidEl = response;

             isValid = false;
           } else {
             response && response.classList.remove('validationElement');
             responseVMsg.style.display = 'none';
            //  isValid = true;
           }


    if (scrollCb) {
      scrollCb(invalidEl);
    }
    return isValid;
  });

  return isValid;
};

export default validateQuestionLevels;
